import React from "react";
import { string } from "prop-types";

const LoginMobile = ({ color = "", datatrackingcategory = "", datatrackingaction = "", datatrackinglabel = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="20.571"
    data-tracking-category={datatrackingcategory}
    data-tracking-action={datatrackingaction}
    data-tracking-label={datatrackinglabel}
  >
    <defs />
    <g data-name="Group 3645">
      <path
        fill={color}
        d="M9 10.286a5.143 5.143 0 10-5.143-5.143A5.142 5.142 0 009 10.286zm3.6 1.286h-.671a6.994 6.994 0 01-5.858 0H5.4a5.4 5.4 0 00-5.4 5.4v1.671a1.929 1.929 0 001.929 1.929h14.142A1.929 1.929 0 0018 18.643v-1.672a5.4 5.4 0 00-5.4-5.4z"
        data-name="Path 226"
      />
    </g>
  </svg>
);

LoginMobile.propTypes = {
  color: string,
  datatrackingcategory: string,
  datatrackingaction: string,
  datatrackinglabel: string,
};

export default LoginMobile;
